import Login from './index.vue'
if (!window.comps) {
    window.comps = {}
}
window.comps.Login = Login